import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
  RemoteConfig,
} from "firebase/remote-config";
import { captureException } from "./sentry";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

class FirebaseRemoteConfig {
  private static instance: FirebaseRemoteConfig;
  private remoteConfig: RemoteConfig;

  private constructor() {
    const app = initializeApp(firebaseConfig);
    this.remoteConfig = getRemoteConfig(app);
    this.remoteConfig.settings.minimumFetchIntervalMillis = 900000; // 15 minutos
  }

  // Singleton para garantir uma única instância
  public static getInstance(): FirebaseRemoteConfig {
    if (!FirebaseRemoteConfig.instance) {
      FirebaseRemoteConfig.instance = new FirebaseRemoteConfig();
    }
    return FirebaseRemoteConfig.instance;
  }

  public async fetchAndActivateConfig(): Promise<void> {
    try {
      await fetchAndActivate(this.remoteConfig);
    } catch (error) {
      console.error("Erro ao ativar o Remote Config", error);
      captureException(error);
    }
  }

  public async getValue<T>(key: string): Promise<T | null> {
    try {
      const value = getValue(this.remoteConfig, key).asString();

      // Tenta determinar o tipo do valor e fazer o parse correto
      if (value === "true" || value === "false") {
        return (value === "true") as T; // Retorna como boolean
      }

      if (!isNaN(Number(value))) {
        return Number(value) as T; // Retorna como number
      }

      try {
        return JSON.parse(value) as T; // Tenta fazer o parse como JSON
      } catch {
        return value as T; // Retorna como string se não for JSON
      }
    } catch (error) {
      console.error(`Erro ao buscar a chave "${key}" do Remote Config`, error);
      return null;
    }
  }
}

export default FirebaseRemoteConfig;
